import { CaseReducer, PayloadAction } from '@reduxjs/toolkit';

// MODEL
import {
  AACCheckInCheckOutState,
  CheckInCheckOutStep,
  ActivityAttendance,
  VerificationRole,
  AACVolunteerData,
  AACCheckInCheckOutResponse,
  VerificationVolunteerType,
  AACValidateProfileError
} from 'model';

export const changeCheckInCheckOutAacLoading: CaseReducer<AACCheckInCheckOutState, PayloadAction<boolean>> = (
  state,
  action
) => {
  state.loading = action.payload;
};

export const changeCheckInCheckOutAacVerificationRole: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<undefined | VerificationRole>
> = (state, action) => {
  state.verificationRole = action.payload;
};

export const changeCheckInCheckOutAacVerificationType: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<undefined | VerificationVolunteerType>
> = (state, action) => {
  state.verificationType = action.payload;
};

export const changeCheckInCheckOutAacVerificationValue: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<string | undefined>
> = (state, action) => {
  state.verificationValue = action.payload;
};

export const changeCheckInCheckOutAacNumberOfVolunteers: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<number | undefined>
> = (state, action) => {
  state.numberOfVolunteers = action.payload;
};

export const changeCheckInCheckOutAacVolunteerData: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<undefined | AACVolunteerData>
> = (state, action) => {
  state.volunteerData = action.payload;
};

export const changeCheckInCheckOutAacSelectedEvent: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<undefined | ActivityAttendance>
> = (state, action) => {
  state.selectedEvent = action.payload;
};

export const changeCheckInCheckOutAacNRIC: CaseReducer<AACCheckInCheckOutState, PayloadAction<string | undefined>> = (
  state,
  action
) => {
  state.nric = action.payload;
};

export const changeCheckInCheckOutAacEmail: CaseReducer<AACCheckInCheckOutState, PayloadAction<string | undefined>> = (
  state,
  action
) => {
  state.email = action.payload;
};

export const changeCheckInCheckOutAacShowSomethingWentWrong: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<boolean>
> = (state, action) => {
  state.showSomethingWentWrong = action.payload;
};

export const changeCheckInCheckOutAacValidateProfileError: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<AACValidateProfileError | undefined>
> = (state, action) => {
  state.validateProfileError = action.payload;
};

export const setCheckInCheckOutStep: CaseReducer<AACCheckInCheckOutState, PayloadAction<CheckInCheckOutStep>> = (
  state,
  action
) => {
  state.step = action.payload;
};

export const setAACCheckInCheckOutData: CaseReducer<
  AACCheckInCheckOutState,
  PayloadAction<AACCheckInCheckOutResponse | undefined>
> = (state, action) => {
  state.checkInCheckOut = action.payload;
};
